import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';
import { fetchConfig } from '@theme/utilities';

/**
 * CTAs das seções NW (kit, destaque de produto): adiciona a variante ao carrinho
 * e deixa o cart drawer abrir sozinho, igual aos cards de produto do tema.
 * Markup: <a href="{{ product.url }}" data-nw-add-to-cart="{{ variant.id }}">.
 * O href continua sendo o fallback (PDP) se o JS falhar.
 */
if (!window.__nwQuickAdd) {
  window.__nwQuickAdd = true;

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target.closest('[data-nw-add-to-cart]') : null;
    if (!(target instanceof HTMLElement)) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey) return;

    event.preventDefault();
    if (target.getAttribute('aria-busy') === 'true') return;
    addToCart(target);
  });
}

/** @param {HTMLElement} trigger */
async function addToCart(trigger) {
  const variantId = trigger.dataset.nwAddToCart;
  const quantity = Number(trigger.dataset.quantity) || 1;
  const fallbackUrl = trigger.getAttribute('href');

  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => (el instanceof HTMLElement ? el.dataset.sectionId : ''))
    .filter(Boolean);

  const formData = new FormData();
  formData.append('id', String(variantId));
  formData.append('quantity', String(quantity));
  if (sectionIds.length) formData.append('sections', sectionIds.join(','));

  const deferred = CartLinesUpdateEvent.createPromise();
  trigger.setAttribute('aria-busy', 'true');

  trigger.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(variantId), quantity }],
      promise: deferred.promise,
    })
  );

  try {
    const fetchCfg = fetchConfig('javascript', { body: formData });
    const response = await fetch(Theme.routes.cart_add_url, {
      ...fetchCfg,
      headers: { ...fetchCfg.headers, Accept: 'text/html' },
    }).then((res) => res.json());

    const ajaxCart = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then(
      (res) => res.json()
    );

    if (response.status) {
      trigger.dispatchEvent(
        new CartErrorEvent({ error: response.message || 'Add to cart failed', code: 'INVALID' })
      );
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
        detail: { didError: true, items: ajaxCart.items, source: 'nw-quick-add', itemCount: quantity },
      });
      if (fallbackUrl) window.location.href = fallbackUrl;
      return;
    }

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
      detail: {
        didError: false,
        items: ajaxCart.items,
        source: 'nw-quick-add',
        itemCount: quantity,
        sections: response.sections,
      },
    });
  } catch (error) {
    console.error(error);
    deferred.reject(error);
    if (fallbackUrl) window.location.href = fallbackUrl;
  } finally {
    trigger.removeAttribute('aria-busy');
  }
}
